import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled, { css } from "styled-components";
import { Flex, Text } from "sprout-ui-primitives";
import { media, themeGet } from "sprout-ui-theme";
const PageHeaderWrapper = styled(Flex)`
  /* ${media.target("touch")} {
    display: none;
  } */

  /* ${media.down("medium", "pointer")} {
    display: none;
  } */

  ${({ $titleDivider  })=>$titleDivider && css`
      ${media.up("medium", "pointer")} {
        position: relative;
        ::before,
        ::after {
          content: "";
          flex: 1;
          border-bottom: 1px solid ${themeGet("colors.blue.500")};
          margin-top: auto;
          margin-bottom: auto;
        }
      }
    `}
`;
const PageHeaderDescription = styled(Text)`
  margin-top: 8px;

  ${media.up("medium", "pointer")} {
    margin-top: 4px;
  }
`;
const PageHeader = (props)=>{
    const { title , titleDivider =true , beforeTitle , afterTitle , description , aboveTitle ,  } = props;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            aboveTitle,
            /*#__PURE__*/ _jsxs(PageHeaderWrapper, {
                $titleDivider: titleDivider,
                mb: description ? null : 5,
                alignItems: "center",
                justifyContent: "center",
                children: [
                    beforeTitle,
                    /*#__PURE__*/ _jsx(Text, {
                        as: "h1",
                        px: 2,
                        fontWeight: "bold",
                        fontSize: [
                            "34px",
                            null,
                            "45px"
                        ],
                        truncate: true,
                        children: title
                    }),
                    afterTitle
                ]
            }),
            description && /*#__PURE__*/ _jsx(PageHeaderDescription, {
                as: "p",
                textAlign: "center",
                lineHeight: 1.5,
                mb: 3,
                children: description
            })
        ]
    });
};
export default PageHeader;
